import React, { useEffect, useState } from "react";
import Images from "../../../Images";
import {
  CombineInputGroup,
  InputGroup,
  Label,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";

export default function RentDetails({
  tenantData,
  setSelectedData,
  selectedData,
  addRentDetailMutate,
  isRentDetailLoading,
}) {
  const [tenant, setTenantData] = useState(tenantData?.tenant);

  useEffect(() => {
    setTenantData(tenantData?.tenant);
  }, [tenantData]);

  const rentFormik = useFormik({
    initialValues: {
      rent: tenant?.rent ?? "",
      security: tenant?.security ?? "",
      moveInDate: moment(tenant?.moveInDate).format("YYYY-MM-DD") ?? "",
      totalDues: tenantData?.totalDues ?? "",
      rentalCycle: tenant?.rentalCycle ?? "",
      agreementPeriod: tenant?.agreementPeriod?.toString() ?? "",
      lockInPeriod: tenant?.lockInPeriod?.toString() ?? "",
      noticePeriod: tenant?.noticePeriod?.toString() ?? "",
      moveOutDate: tenant?.moveOutDate ?? "",
    },
    validationSchema: Yup.object({
      rent: Yup.number(),
      // security: Yup.number().required("Security is required"),
      moveInDate: Yup.date(),
      // totalDues: Yup.number().required("Total Dues is required"),
      rentalCycle: Yup.string(),
      agreementPeriod: Yup.number(),
      lockInPeriod: Yup.number(),
      noticePeriod: Yup.number(),
      moveOutDate: Yup.date().nullable(),
    }),
    onSubmit: (values) => {
      if(!values.rent) {
        toast.error("Rent is required");
        return;
      }
      if(!values.rentalCycle) {
        toast.error("Rental Cycle is required");
        return;
      }
      if(!values.agreementPeriod) {
        toast.error("Agreement Period is required");
        return;
      }
      if(!values.lockInPeriod) {
        toast.error("Lock-in Period is required ");
        return;
      }
      if(!values.noticePeriod) {
        toast.error("Notice Period is required");
        return;
      }
      if(!values.moveInDate) {
        toast.error("Move In Date is required");
        return;
      }
      addRentDetailMutate(values);
    },
    enableReinitialize: true,
  });

  return (
    <>
      <div>
        <Title>Rent Details</Title>
        <form
          onSubmit={rentFormik.handleSubmit}
          className="grid grid-cols-1 gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="rent">Rent (₹)</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="rent"
                  name="rent"
                  value={rentFormik.values.rent}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      rentFormik.setFieldValue("rent", value);
                    }
                  }}
                  onBlur={rentFormik.handleBlur}
                />
                {rentFormik.touched.rent && rentFormik.errors.rent && (
                  <p className="text-rose-600 text-sm">
                    {rentFormik.errors.rent}
                  </p>
                )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="security">Security (₹)</Label>
              <FieldWrapper className="bg-gray-100">
                <Input
                  id="security"
                  name="security"
                  disabled
                  value={rentFormik.values.security}
                  onChange={rentFormik.handleChange}
                />
                {rentFormik.touched.security && rentFormik.errors.security && (
                  <p className="text-rose-600 text-sm">
                    {rentFormik.errors.security}
                  </p>
                )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              {/* <Label htmlFor="moveInDate">Moved In</Label> */}
              <Label htmlFor="moveInDate">Move-In Date *</Label>
              <FieldWrapper className="relative">
                <Input
                  type="date"
                  name="moveInDate"
                  id="moveInDate"
                  className="pl-3"
                  value={rentFormik.values.moveInDate}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                />
                {rentFormik.touched.moveInDate &&
                  rentFormik.errors.moveInDate && (
                    <p className="text-rose-600 text-sm">
                      {rentFormik.errors.moveInDate}
                    </p>
                  )}
                {/* <img
                  src={Images.Calender}
                  alt="Calendar icon"
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 cursor-pointer"
                /> */}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>

          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="totalDues">Total Dues (₹)</Label>
              <FieldWrapper className="bg-gray-100">
                <Input
                  id="totalDues"
                  name="totalDues"
                  disabled
                  onChange={rentFormik.handleChange}
                  value={rentFormik.values.totalDues}
                />
                {rentFormik.touched.totalDues &&
                  rentFormik.errors.totalDues && (
                    <p className="text-rose-600 text-sm">
                      {rentFormik.errors.totalDues}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="rentalCycle">Rental Cycle</Label>
              <FieldWrapper className="relative">
                <Input
                  type="text"
                  name="rentalCycle"
                  id="rentalCycle"
                  value={rentFormik.values.rentalCycle}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      /^\d*$/.test(value) &&
                      (value === "" ||
                        (Number(value) >= 1 && Number(value) <= 31))
                    ) {
                      rentFormik.setFieldValue("rentalCycle", value);
                    }
                  }}
                  onBlur={rentFormik.handleBlur}
                />
                {rentFormik.touched.rentalCycle &&
                  rentFormik.errors.rentalCycle && (
                    <p className="text-rose-600 text-sm">
                      {rentFormik.errors.rentalCycle}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="agreementPeriod">Agreement Period (Months)</Label>
              <FieldWrapper>
                <Select
                  id="agreementPeriod"
                  name="agreementPeriod"
                  className="w-full pl-2"
                  value={rentFormik.values.agreementPeriod}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                >
                  {[...Array(24).keys()].map((num) => {
                    const value = (num + 1) * 0.5;
                    return (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    );
                  })}
                </Select>
                {rentFormik.touched.agreementPeriod &&
                  rentFormik.errors.agreementPeriod && (
                    <p className="text-rose-600 text-sm">
                      {rentFormik.errors.agreementPeriod}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="lockInPeriod">Lock-in Period (Months)</Label>
              <FieldWrapper>
                <Select
                  id="lockInPeriod"
                  name="lockInPeriod"
                  className="w-full pl-2"
                  value={rentFormik.values.lockInPeriod}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                >
                  {[...Array(24).keys()].map((num) => {
                    const value = (num + 1) * 0.5;
                    return (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    );
                  })}
                </Select>
                {rentFormik.touched.lockInPeriod &&
                  rentFormik.errors.lockInPeriod && (
                    <p className="text-rose-600 text-sm">
                      {rentFormik.errors.lockInPeriod}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="noticePeriod">Notice Period (Months)</Label>
              <FieldWrapper>
                <Select
                  id="noticePeriod"
                  name="noticePeriod"
                  className="w-full pl-2"
                  value={rentFormik.values.noticePeriod}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                >
                  {[...Array(24).keys()].map((num) => {
                    const value = (num + 1) * 0.5;
                    return (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    );
                  })}
                </Select>
                {rentFormik.touched.noticePeriod &&
                  rentFormik.errors.noticePeriod && (
                    <p className="text-rose-600 text-sm">
                      {rentFormik.errors.noticePeriod}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              {/* <Label htmlFor="moveOutDate">Moved Out</Label> */}
              <Label htmlFor="moveInDate">Moved-Out Date *</Label>
              <FieldWrapper className="relative">
                <Input
                  type="date"
                  name="moveOutDate"
                  id="moveOutDate"
                  className="pl-3"
                  value={rentFormik.values.moveOutDate}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                />
                {rentFormik.touched.moveOutDate &&
                  rentFormik.errors.moveOutDate && (
                    <p className="text-rose-600 text-sm">
                      {rentFormik.errors.moveOutDate}
                    </p>
                  )}
                {/* <img
                  src={Images.Calender}
                  alt="Calendar icon"
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 cursor-pointer"
                /> */}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn
              type="submit"
              disabled={isRentDetailLoading}
              // onClick={() => console.log("Button clicked")}
            >
              {isRentDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </div>
    </>
  );
}

const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;

const SubmitBtn = tw.button`
text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-full shadow-md`;
